export default __webpack_public_path__ + "static/media/twel.ece63d46.jpg";